export default __webpack_public_path__ + "static/G7_ND_Breadown_ConflictDisastersRGB-96ed8576b0b6bb0447e3dda25aa221ba.jpg";